/**
 * 所有接口地址
 */

const PREFIX = '/portal';

export const API = {
    // 账号相关
    account: {
        /** 获取sso令牌 */
        get_bridge_token: `${PREFIX}/account/get_bridge_token`,
        /** 更新个人账号信息 */
        update_user: `${PREFIX}/account/update_user`,
        /** 获取个人账号信息 */
        get_user: `${PREFIX}/account/get_user`,
        /** 更新个人语言 */
        update_locale: `${PREFIX}/account/update_locale`,
        /** 自主登录/注册后通过选择接受邀请（手机号/邮箱邀请） */
        batch_join_corp: `${PREFIX}/account/corp/batch_join_corp`,
        /** 用户加入企业确认 */
        join_corp: `${PREFIX}/account/corp/join_corp`,
        /** 成员主动退出企业 */
        exit_corp: `${PREFIX}/account/corp/exit_corp`,
        /** 获取用户注销信息 */
        account_delete_info: `${PREFIX}/account/cancel/get_cancel_progress`,
        /** 用户撤回注销 */
        account_delete_cancel: `${PREFIX}/account/cancel/abort_cancel`,
        /** 用户立即注销 */
        account_delete_immediately: `${PREFIX}/account/cancel/execute_cancel`,
        /** 帆软通行证解绑 */
        fanruan_unbind: `${PREFIX}/account/provider/fanruan/unbind`,
        /** google 解绑 */
        google_unbind: `${PREFIX}/account/provider/google/unbind`,
        /** 微信开放平台授权解绑 */
        wechat_unbind: `${PREFIX}/account/provider/wechat/unbind`,
        /** 查询公开链接企业信息 */
        corp_public_get: `${PREFIX}/account/corp/public_get`,
        /** 个人账号设置-注销校验 */
        account_delete_check: `${PREFIX}/account/cancel/check_cancel`,
        /** 个人账号设置-触发注销 */
        account_delete: `${PREFIX}/account/cancel/issue_cancel`
    },
    audit: {
        /** 获取企业日志展示项 */
        get_log_categories: `${PREFIX}/tenant/:tenantId/admin/audit/get_log_categories`,
        /** 查询登录日志 */
        get_login_log_list: `${PREFIX}/tenant/:tenantId/admin/audit/get_login_log_list`,
        /** 查询操作日志 */
        get_operate_log_list: `${PREFIX}/tenant/:tenantId/admin/audit/get_operate_log_list`,
        /** 导出登录日志 */
        export_login_log: `${PREFIX}/tenant/:tenantId/admin/audit/export_login_log`,
        /** 导出操作日志 */
        export_operate_log: `${PREFIX}/tenant/:tenantId/admin/audit/export_operate_log`,
        /** 获取登录统计数据概览（折线图） */
        login_report_list: `${PREFIX}/tenant/:tenantId/admin/audit/login_report_list`,
        /** 查询月度登录指标卡 */
        login_summary: `${PREFIX}/tenant/:tenantId/admin/audit/login_summary`,
        /** 获取登录统计数据详情 */
        login_metrics: `${PREFIX}/tenant/:tenantId/admin/audit/login_metrics`,
        /** 导出登录统计数据 */
        export_login_stats: `${PREFIX}/tenant/:tenantId/admin/audit/export_login_stats`
    },
    authn: {
        cp_auth: {
            /** 获取 Corp Secret 授权列表 */
            list: `${PREFIX}/authn/cp_auth/list`,
            /** 更新 Corp Secret 授权信息 */
            update: `${PREFIX}/authn/cp_auth/update`,
            /** 删除 Corp Secret 授权信息 */
            delete: `${PREFIX}/authn/cp_auth/delete`
        }
    },
    branding: {
        /** 更新企业 url */
        update_corp_url: `${PREFIX}/tenant/:tenantId/admin/branding/update_corp_url`,
        /** 更新自定义登录页 */
        update_custom_login: `${PREFIX}/tenant/:tenantId/admin/branding/update_custom_login`,
        /** 更新企业风格 */
        update_corp_theme: `${PREFIX}/tenant/:tenantId/admin/branding/update_corp_theme`
    },
    conf: {
        /** 获取企业信息 */
        get_tenant_conf: `${PREFIX}/tenant/:tenantId/admin/conf/get_tenant_conf`,
        /** 获取用户画像标签 */
        get_persona_label: `${PREFIX}/persona/get_persona_label`,
        /** 获取用户画像 */
        get_persona: `${PREFIX}/tenant/:tenantId/admin/persona/get_persona`,
        /** 更新用户画像 */
        update_persona: `${PREFIX}/tenant/:tenantId/admin/persona/update_persona`,
        /** 更新注册信息 */
        update_register_info: `${PREFIX}/tenant/:tenantId/admin/persona/update_register_info`,
        /** 获取推荐标签 */
        get_recommended_label: `${PREFIX}/tenant/:tenantId/admin/persona/get_recommended_label`,
        /** 搜索企业 */
        search_corp: `${PREFIX}/persona/search_corp`
    },
    owner: {
        /** 创建者转交前校验 */
        transfer_check: `${PREFIX}/tenant/:tenantId/admin/owner/transfer/check`,
        /** 转交创建者 */
        transfer_submit: `${PREFIX}/tenant/:tenantId/admin/owner/transfer/submit`
    },
    manage_group: {
        /** 管理员-通讯录管理组-查看管理组信息 */
        get: `${PREFIX}/tenant/:tenantId/admin/manage_group/get_manage_group`,
        /** 管理员-系统管理组-查看信息 */
        get_sys: `${PREFIX}/tenant/:tenantId/admin/manage_group/get_sys_admin_group`,
        /** 权限查询-系统管理组查询 */
        search: `${PREFIX}/tenant/:tenantId/admin/manage_group/search_manage_group_list`,
        /** 管理员-通讯录管理组-查看列表 */
        list: `${PREFIX}/tenant/:tenantId/admin/manage_group/get_manage_group_list`,
        /** 管理员-通讯录管理组-创建 */
        create: `${PREFIX}/tenant/:tenantId/admin/manage_group/create_manage_group`,
        /** 管理员-通讯录管理组-更新 */
        update: `${PREFIX}/tenant/:tenantId/admin/manage_group/update_manage_group`,
        /** 管理员-通讯录管理组-删除 */
        delete: `${PREFIX}/tenant/:tenantId/admin/manage_group/delete_manage_group`,
        /** 管理员-通讯录管理组-排序 */
        sort: `${PREFIX}/tenant/:tenantId/admin/manage_group/sort_manage_group`
    },
    open: {
        /** 查询开放平台管理员列表 */
        get_manager: `${PREFIX}/v1/open_platform_manager/get`,
        /** 保存开放平台管理员列表 */
        update_manager: `${PREFIX}/v1/open_platform_manager/update`,
        store: {
            data_source_detail: `${PREFIX}/open/store/data_source/detail`,
            plugin_detail: `${PREFIX}/open/store/plugin/detail`
        },
        /** 自建应用 */
        application: {
            create: `${PREFIX}/tenant/:tenantId/admin/open_application/create`,
            list: `${PREFIX}/tenant/:tenantId/admin/open_application/list`,
            get: `${PREFIX}/tenant/:tenantId/admin/open_application/get`,
            update: `${PREFIX}/tenant/:tenantId/admin/open_application/update`,
            delete: `${PREFIX}/tenant/:tenantId/admin/open_application/delete`,
            url: `${PREFIX}/tenant/:tenantId/admin/open_application/url`
        },
        key_refresh: `${PREFIX}/tenant/:tenantId/admin/open_application/refresh_secret`
    },
    security: {
        /** 更新企业二次验证开启状态 */
        update_mfa: `${PREFIX}/tenant/:tenantId/admin/security/update_mfa`,
        /** 更新企业水印 */
        update_watermark: `${PREFIX}/tenant/:tenantId/admin/security/update_watermark`
    },
    corp: {
        /** 创建企业 */
        create_tenant: `${PREFIX}/corp/create_tenant`,
        /** 获取当前登录用户所在部门列表 */
        login_user_dept: `${PREFIX}/tenant/:tenantId/login_user_dept`,
        /** 查看企业配置（公开链接邀请、是否允许成员修改昵称、企业名称、默认成员冻结状态、同步模式） */
        get_corp_conf: `${PREFIX}/tenant/:tenantId/admin/corp/get_corp_conf`,
        /** 更新企业配置 */
        update_corp_conf: `${PREFIX}/tenant/:tenantId/admin/corp/update_corp_conf`,
        /** 列出控件成员(管理场景) */
        member_list: `${PREFIX}/tenant/:tenantId/admin/member/list`,
        /** 列出离职人员 */
        list_dismission_member: `${PREFIX}/tenant/:tenantId/admin/member/list_dismissed`,
        /** 获取成员详情 */
        get_member: `${PREFIX}/tenant/:tenantId/admin/member/get`,
        /** 更新单个成员 */
        edit_member: `${PREFIX}/tenant/:tenantId/admin/member/update`,
        /** 批量离职成员 */
        remove_member: `${PREFIX}/tenant/:tenantId/admin/member/delete_batch`,
        /** 批量设置部门 */
        set_dept: `${PREFIX}/tenant/:tenantId/admin/member/update_dept_batch`,
        /** 验证成员对应的注册用户上的未验证属性 */
        channel_verify: `${PREFIX}/tenant/:tenantId/admin/member/verify_channel`,
        /** 离职成员删除 */
        member_hard_delete: `${PREFIX}/tenant/:tenantId/admin/member/delete_dismission_member`,
        /** 批量停用成员 */
        member_freeze: `${PREFIX}/tenant/:tenantId/admin/member/freeze_member`,
        /** 批量启用成员 */
        member_recover: `${PREFIX}/tenant/:tenantId/admin/member/recover_member`,
        /** 获取成员 Excel 上传的token */
        get_member_excel_token: `${PREFIX}/tenant/:tenantId/admin/member/get_import_token`,
        excel_process: {
            /** 成员 Excel 导入 */
            import_member: `${PREFIX}/tenant/:tenantId/admin/member/import`,
            /** 导入错误内容 Excel 导出 */
            error_export: `${PREFIX}/tenant/:tenantId/admin/member/export_import_error`,
            /** 免审成员 Excel 导入 */
            exempt_trial_import_member: `${PREFIX}/tenant/:tenantId/admin/user/import`,
            /** 免审错误内容 Excel 导出 */
            exempt_trial_error_export: `${PREFIX}/tenant/:tenantId/admin/user/export_import_error`,
            member_role_rel: {
                /** 获取角色成员关系 Excel 上传的token */
                get_import_token: `${PREFIX}/tenant/:tenantId/admin/member_role_rel/get_import_token`,
                /** Excel导入角色与成员关联. */
                excel_import: `${PREFIX}/tenant/:tenantId/admin/member_role_rel/import`,
                /** Excel导出角色与成员关联. */
                excel_export: `${PREFIX}/tenant/:tenantId/admin/member_role_rel/export`,
                /** 导出导入时的错误 */
                error_export: `${PREFIX}/tenant/:tenantId/admin/member_role_rel/export_import_error`
            }
        },
        /** 成员 Excel 导出 */
        contact_member_export: `${PREFIX}/tenant/:tenantId/admin/member/export`,
        /** 成员邀请 */
        invite: `${PREFIX}/tenant/:tenantId/admin/member/invite`,
        /** 成员重新邀请 */
        reinvite: `${PREFIX}/tenant/:tenantId/admin/member/reinvite`,
        /** 成员唯一性字段校验 */
        uniq_check: `${PREFIX}/tenant/:tenantId/admin/member/check_uniq`,
        /** 列出部门 */
        department_list: `${PREFIX}/tenant/:tenantId/admin/dept/get_dept_list`,
        /** 列出部门下成员 */
        department_list_member: `${PREFIX}/tenant/:tenantId/admin/dept/get_member_list`,
        /** 统计部门成员 */
        count_member: `${PREFIX}/tenant/:tenantId/admin/dept/count_member`,
        /** 创建部门 */
        department_create: `${PREFIX}/tenant/:tenantId/admin/dept/create`,
        /** 修改部门 */
        department_edit: `${PREFIX}/tenant/:tenantId/admin/dept/update`,
        /** 删除部门 */
        department_remove: `${PREFIX}/tenant/:tenantId/admin/dept/delete`,
        /** 更新部门邀请链接配置. */
        invitation_update: `${PREFIX}/tenant/:tenantId/admin/dept/update_invitation`,
        /** 查询部门邀请链接配置. */
        invitation_get: `${PREFIX}/tenant/:tenantId/admin/dept/get_invitation`,
        /** 部门排序. */
        dept_sort: `${PREFIX}/tenant/:tenantId/admin/dept/sort_dept`,
        /** 获取部门主管. */
        get_manager: `${PREFIX}/tenant/:tenantId/admin/dept/get_manager`,
        /** 设置部门主管. */
        set_manager: `${PREFIX}/tenant/:tenantId/admin/dept/update_manager`,
        /** 列出角色. */
        role_list: `${PREFIX}/tenant/:tenantId/admin/role/get_role_list`,
        /** 创建角色. */
        role_create: `${PREFIX}/tenant/:tenantId/admin/role/create`,
        /** 修改角色. */
        role_update: `${PREFIX}/tenant/:tenantId/admin/role/update`,
        /** 删除角色. */
        role_remove: `${PREFIX}/tenant/:tenantId/admin/role/delete`,
        /** 列出角色下成员. */
        role_list_member: `${PREFIX}/tenant/:tenantId/admin/role/get_member_list`,
        /** 设置角色下成员. */
        set_member: `${PREFIX}/tenant/:tenantId/admin/role/set_member`,
        /** 角色排序. */
        role_sort: `${PREFIX}/tenant/:tenantId/admin/role/sort_role`,
        /** 批量设置成员 - 角色关系分管部门范围. */
        role_scope_update: `${PREFIX}/tenant/:tenantId/admin/member_role_rel/update_scope`,
        /** 修改角色组. */
        role_group_update: `${PREFIX}/tenant/:tenantId/admin/role_group/update`,
        /** 删除角色组. */
        role_group_remove: `${PREFIX}/tenant/:tenantId/admin/role_group/delete`,
        /** 角色组排序. */
        role_group_sort: `${PREFIX}/tenant/:tenantId/admin/role_group/sort`,
        /** 创建角色组. */
        role_group_add: `${PREFIX}/tenant/:tenantId/admin/role_group/create`,
        /** 列出角色组. */
        role_group_list: `${PREFIX}/tenant/:tenantId/admin/role_group/get_role_group_list`,
        /** 成员详情. */
        user_detail: `${PREFIX}/tenant/:tenantId/corp/member/get_member_detail`,
        /** 部门详情. */
        dept_detail: `${PREFIX}/tenant/:tenantId/corp/dept/get_dept_detail`,
        /** 角色详情. */
        role_detail: `${PREFIX}/tenant/:tenantId/corp/role/get_role_detail`,
        /** 获取成员表格字段排序与显隐 */
        view_get: `${PREFIX}/tenant/:tenantId/admin/member/view/get`,
        /** 更新成员表格字段排序与显隐 */
        view_update: `${PREFIX}/tenant/:tenantId/admin/member/view/update`,
        batch_update_task: {
            /** 统计批量修改的成员数量 */
            count_member: `${PREFIX}/tenant/:tenantId/admin/member/batch_update_task/count_member`,
            /** 触发批量修改任务 */
            create: `${PREFIX}/tenant/:tenantId/admin/member/batch_update_task/create`,
            /** 查询批量修改任务详情(轮询用) */
            get: `${PREFIX}/tenant/:tenantId/admin/member/batch_update_task/get`
        },
        member_field: {
            /** 删除自定义字段 */
            delete: `${PREFIX}/tenant/:tenantId/admin/member_field/delete`,
            /** 编辑自定义字段 */
            update: `${PREFIX}/tenant/:tenantId/admin/member_field/update`,
            /** 新增自定义字段 */
            create: `${PREFIX}/tenant/:tenantId/admin/member_field/create`,
            /** 自定义字段排序 */
            sort: `${PREFIX}/tenant/:tenantId/admin/member_field/sort`,
            /** 获取可管理字段列表 */
            list: `${PREFIX}/tenant/:tenantId/admin/member_field/list`,
            /** 同上，成员级别 */
            list_view: `${PREFIX}/tenant/:tenantId/member_field/list`,
            /** 批量更新字段 */
            batch_update: `${PREFIX}/tenant/:tenantId/admin/member_field/update_scenes_batch`
        },
        contact_rebind: {
            export: `${PREFIX}/tenant/:tenantId/admin/contact_rebind/export`
        }
    },
    external: {
        member: {
            /** 获取外部离职成员列表 */
            list_dismissed: `${PREFIX}/tenant/:tenantId/admin/external/member/list_dismissed`,
            /** 获取外部成员组织列表 */
            get_member_list: `${PREFIX}/tenant/:tenantId/admin/external/member/get_member_list`,
            /** 获取外部成员列表 */
            list: `${PREFIX}/tenant/:tenantId/admin/external/member/list`,
            /** 获取外部成员详情 */
            get: `${PREFIX}/tenant/:tenantId/admin/external/member/get`,
            /** 邀请外部成员 */
            invite: `${PREFIX}/tenant/:tenantId/admin/external/member/invite`,
            /** 更新外部成员 */
            update: `${PREFIX}/tenant/:tenantId/admin/external/member/update`,
            /** 获取外部成员未加入统计 */
            count_member: `${PREFIX}/tenant/:tenantId/admin/external/member/count_member`,
            /** 再次邀请外部成员 */
            reinvite: `${PREFIX}/tenant/:tenantId/admin/external/member/reinvite`,
            /** 验证外部成员渠道 */
            verify_channel: `${PREFIX}/tenant/:tenantId/admin/external/member/verify_channel`,
            /** 批量停用外部成员 */
            freeze_member: `${PREFIX}/tenant/:tenantId/admin/external/member/freeze_member`,
            /** 批量启用外部成员 */
            recover_member: `${PREFIX}/tenant/:tenantId/admin/external/member/recover_member`,
            /** 批量将外部成员转为离职 */
            delete_batch: `${PREFIX}/tenant/:tenantId/admin/external/member/delete_batch`,
            /** 彻底删除外部离职成员 */
            delete_dismission_member: `${PREFIX}/tenant/:tenantId/admin/external/member/delete_dismission_member`,
            /** 获取外部成员导入上传 Token */
            get_import_token: `${PREFIX}/tenant/:tenantId/admin/external/member/get_import_token`,
            /** Excel 导入外部成员 */
            import: `${PREFIX}/tenant/:tenantId/admin/external/member/import`,
            /** 导出外部成员导入错误 */
            export_import_error: `${PREFIX}/tenant/:tenantId/admin/external/member/export_import_error`,
            /** 导出外部成员 */
            export: `${PREFIX}/tenant/:tenantId/admin/external/member/export`
        },
        user: {
            /** 免审导入外部账号及成员 */
            import: `${PREFIX}/tenant/:tenantId/admin/external/user/import`,
            /** 导出外部免审导入错误 */
            export_import_error: `${PREFIX}/tenant/:tenantId/admin/external/user/export_import_error`
        },
        invitation: {
            /** 获取外部成员公开邀请配置 */
            get_invitation: `${PREFIX}/tenant/:tenantId/admin/external/get_invitation`,
            /** 更新外部成员公开邀请配置 */
            update_invitation: `${PREFIX}/tenant/:tenantId/admin/external/update_invitation`
        },
        role: {
            /** 获取外部角色列表 */
            get_role_list: `${PREFIX}/tenant/:tenantId/admin/external/role/get_role_list`,
            /** 创建外部角色 */
            create: `${PREFIX}/tenant/:tenantId/admin/external/role/create`,
            /** 更新外部角色 */
            update: `${PREFIX}/tenant/:tenantId/admin/external/role/update`,
            /** 删除外部角色 */
            delete: `${PREFIX}/tenant/:tenantId/admin/external/role/delete`,
            /** 获取外部角色下成员列表 */
            get_member_list: `${PREFIX}/tenant/:tenantId/admin/external/role/get_member_list`,
            /** 设置外部角色成员 */
            set_member: `${PREFIX}/tenant/:tenantId/admin/external/role/set_member`,
            /** 外部角色排序 */
            sort_role: `${PREFIX}/tenant/:tenantId/admin/external/role/sort_role`
        },
        role_group: {
            /** 创建外部角色组 */
            create: `${PREFIX}/tenant/:tenantId/admin/external/role_group/create`,
            /** 获取外部角色组列表 */
            get_role_group_list: `${PREFIX}/tenant/:tenantId/admin/external/role_group/get_role_group_list`,
            /** 更新外部角色组 */
            update: `${PREFIX}/tenant/:tenantId/admin/external/role_group/update`,
            /** 删除外部角色组 */
            delete: `${PREFIX}/tenant/:tenantId/admin/external/role_group/delete`,
            /** 外部角色组排序 */
            sort: `${PREFIX}/tenant/:tenantId/admin/external/role_group/sort`
        },
        member_role_rel: {
            /** 获取外部角色成员关系导入上传 Token */
            get_import_token: `${PREFIX}/tenant/:tenantId/admin/external/member_role_rel/get_import_token`,
            /** Excel 导入外部角色成员关系 */
            import: `${PREFIX}/tenant/:tenantId/admin/external/member_role_rel/import`,
            /** 导出外部角色成员关系导入错误 */
            export_import_error: `${PREFIX}/tenant/:tenantId/admin/external/member_role_rel/export_import_error`,
            /** 导出外部角色成员关系 */
            export: `${PREFIX}/tenant/:tenantId/admin/external/member_role_rel/export`
        }
    },
    handover: {
        /** 获取交接选项列表 */
        list_content: `${PREFIX}/tenant/:tenantId/admin/handover/list_content`,
        /** 开始交接任务 */
        start_task: `${PREFIX}/tenant/:tenantId/admin/handover/start_task`,
        /** 轮询查看交接进度与状态 */
        get_task_status: `${PREFIX}/tenant/:tenantId/admin/handover/get_task_status`
    },
    corp_coop: {
        /** 获取客体企业概览 */
        get_overview: `${PREFIX}/tenant/:tenantId/admin/corp_coop/get_overview`,
        /** 获取客体企业统计数据 */
        get_stats: `${PREFIX}/tenant/:tenantId/admin/corp_coop/get_stats`,
        guest: {
            /** 导入后客体手动填写确认链接检查, 并生成私有链接 */
            check_import: `${PREFIX}/corp_coop/guest/check_import`,
            /** 列出客体部门 */
            get_guest_list: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest/get_guest_list`,
            /** 统计客体企业指标 */
            get_guest_stats: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest/get_guest_stats`,
            /** 获取代管理企业列表 */
            get_tmp_owned_guest_list: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest/get_tmp_owned_guest_list`,
            /** 申请代管通讯录 */
            apply_owner: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest/apply_owner`,
            /** 更新客体企业代管通讯录邀请对接人链接状态 */
            delegate_public_link: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest/delegate_public_link`,
            /** 移交客体企业代管理权限 */
            transfer_owner: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest/transfer_owner`,
            /** 导入客体企业 */
            import: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest/import`,
            /** 获取客体企业导入场景，获取上传 Excel 需要的 token */
            get_import_token: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest/get_import_token`,
            /** 重新向客体企业创建人和对接人发送邀请 */
            reinvite_guest: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest/reinvite_guest`,
            /** 更新客体企业 */
            update_guest: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest/update_guest`,
            /** 断开与客体企业连接 */
            disconnect: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest/disconnect`,
            /** 创建互联组织公开邀请链接 */
            create_public_link: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest/create_public_link`,
            /** 更新互联组织公开邀请链接 */
            update_public_link: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest/update_public_link`,
            /** 删除互联组织公开邀请链接 */
            delete_public_link: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest/delete_public_link`,
            /** 列出互联组织公开邀请链接 */
            get_public_link_list: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest/get_public_link_list`
        },
        host: {
            /** 获取主体企业列表 */
            get_host_list: `${PREFIX}/tenant/:tenantId/admin/corp_coop/host/get_host_list`,
            /** 客体向主体发起反向邀请 */
            connect: `${PREFIX}/tenant/:tenantId/admin/corp_coop/host/connect`,
            /** 断开与主体企业连接 */
            disconnect: `${PREFIX}/tenant/:tenantId/admin/corp_coop/host/disconnect`,
            /** 撤销临时代管通讯录权限 */
            revoke_tmp_owner: `${PREFIX}/tenant/:tenantId/admin/corp_coop/host/revoke_tmp_owner`
        },
        our_docker: {
            /** 列出我方对接人 */
            get_our_docker_list: `${PREFIX}/tenant/:tenantId/admin/corp_coop/our_docker/get_our_docker_list`,
            /** 添加我方对接人 */
            add_our_docker: `${PREFIX}/tenant/:tenantId/admin/corp_coop/our_docker/add_our_docker`,
            /** 从全部对接企业中移除我方对接人 */
            delete_our_docker: `${PREFIX}/tenant/:tenantId/admin/corp_coop/our_docker/delete_our_docker`,
            /** 更新我方对接人对接企业 */
            update_our_docker: `${PREFIX}/tenant/:tenantId/admin/corp_coop/our_docker/update_our_docker`
        },
        guest_docker: {
            /** 列出客体企业对接人 */
            list_guest_docker: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest_docker/list_guest_docker`,
            /** 统计客体企业对接人 */
            get_guest_docker_stats: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest_docker/get_guest_docker_stats`,
            /** 在代管理模式下为客体企业创建对接人 */
            create_guest_docker: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest_docker/create_guest_docker`,
            /** 在代管理模式下为客体企业删除对接人 */
            delete_guest_docker: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest_docker/delete_guest_docker`,
            /** 在代管理模式下更新客体企业创建对接人 */
            update_guest_docker: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest_docker/update_guest_docker`,
            /** 获取客体企业对接人详情 */
            get_guest_docker: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest_docker/get_guest_docker`,
            /** 重新向客体企业成员发送邀请 */
            reinvite_guest_docker: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest_docker/reinvite_guest_docker`,
            /** 导出客体企业对接人 */
            export: `${PREFIX}/tenant/:tenantId/admin/corp_coop/guest_docker/export`
        },
        role: {
            /** 创建对接人角色 */
            create_role: `${PREFIX}/tenant/:tenantId/admin/corp_coop/role/create_role`,
            /** 更新对接人角色 */
            update_role: `${PREFIX}/tenant/:tenantId/admin/corp_coop/role/update_role`,
            /** 列出对接人角色 */
            get_role_list: `${PREFIX}/tenant/:tenantId/admin/corp_coop/role/get_role_list`,
            /** 删除对接人角色 */
            delete_role: `${PREFIX}/tenant/:tenantId/admin/corp_coop/role/delete_role`,
            /** 对接人角色排序 */
            sort_role: `${PREFIX}/tenant/:tenantId/admin/corp_coop/role/sort_role`,
            /** 更新角色内成员列表 */
            set_member: `${PREFIX}/tenant/:tenantId/admin/corp_coop/role/set_member`
        },
        dept_label: {
            /** 列出互联组织标签 */
            get_dept_label_list: `${PREFIX}/tenant/:tenantId/admin/corp_coop/dept_label/get_dept_label_list`,
            /** 创建互联组织标签 */
            create_dept_label: `${PREFIX}/tenant/:tenantId/admin/corp_coop/dept_label/create_dept_label`,
            /** 更新互联组织标签 */
            update_dept_label: `${PREFIX}/tenant/:tenantId/admin/corp_coop/dept_label/update_dept_label`,
            /** 删除互联组织标签 */
            delete_dept_label: `${PREFIX}/tenant/:tenantId/admin/corp_coop/dept_label/delete_dept_label`,
            /** 互联组织标签排序 */
            sort_dept_label: `${PREFIX}/tenant/:tenantId/admin/corp_coop/dept_label/sort_dept_label`,
            /** 为部门标签批量添加部门 */
            set_dept: `${PREFIX}/tenant/:tenantId/admin/corp_coop/dept_label/set_dept`
        },
        /** 在互联私有邀请页面，接收邀请 */
        accept_private: `${PREFIX}/corp_coop/accept_private`,
        /** 在互联公开邀请页面，接收邀请 */
        accept_public: `${PREFIX}/corp_coop/accept_public`
    },
    coin: {
        /** 云币余额 */
        get_coin_balance: `${PREFIX}/tenant/:tenantId/admin/coin/get_coin_balance`
    },
    i18n: {
        /** 获取地区选项列表 */
        get_region_list: `${PREFIX}/i18n/get_region_list`,
        /** 更新地区 */
        update_region: `${PREFIX}/tenant/:tenantId/admin/i18n/update_region`,
        /** 查看时区选项列表 */
        get_timezone_list: `${PREFIX}/i18n/get_timezone_list`,
        /** 更新时区 */
        update_timezone: `${PREFIX}/tenant/:tenantId/admin/i18n/update_timezone`,
        /** 查看租户语言选项列表 */
        get_locale_list: `${PREFIX}/i18n/get_locale_list`,
        /** 更新租户语言 */
        update_locale: `${PREFIX}/tenant/:tenantId/admin/i18n/update_locale`
    },
    common: {
        /** 获取公共配置 */
        get_public_configuration: `${PREFIX}/corp/common/get_public_configuration`,
        /** 设置 csrf token 到 Cookie 中 */
        get_csrf: `${PREFIX}/corp/common/get_csrf`
    },
    file: {
        /** 获取公共媒体资源文件上传 Token */
        get_media_token: `${PREFIX}/upload/get_media_token`,
        /** 获取凭证文件上传 Token */
        get_proof_token: `${PREFIX}/upload/get_proof_token`
    },
    verify: {
        /** 查询租户认证状态 */
        status: `${PREFIX}/tenant/:tenantId/verify/get_status`,
        /** 颁发租户认证流程 token */
        token: `${PREFIX}/tenant/:tenantId/admin/verify/issue_verify_token`,
        /** 查询当前认证申请进度 */
        progress: `${PREFIX}/tenant/:tenantId/admin/verify/get_progress`,
        /** 取认证材料附件上传凭证 */
        upload_token: `${PREFIX}/tenant/:tenantId/admin/verify/get_attachment_upload_token`,
        /** 取 Baidu 人脸识别跳转 URL */
        id_card_issue_url: `${PREFIX}/tenant/:tenantId/admin/verify/get_id_card_issue_url`,
        /** 上报身份证信息至 Baidu */
        commit_id_info: `${PREFIX}/tenant/:tenantId/admin/verify/commit_id_info`,
        /** 提交护照个人认证申请 */
        submit_passport: `${PREFIX}/tenant/:tenantId/admin/verify/submit_passport`,
        /** 识别营业执照 */
        recognize_business_license: `${PREFIX}/tenant/:tenantId/admin/verify/recognize_business_license`,
        /** 提交营业执照企业认证申请 */
        submit_business_license: `${PREFIX}/tenant/:tenantId/admin/verify/submit_business_license`
    },
    message: {
        /** 是否有未读消息 */
        get_has_unread: `${PREFIX}/v1/message_center/get_has_unread`,
        /** 获取用户消息 */
        list: `${PREFIX}/v1/message_center/list`,
        /** 获取消息展示界面的交互分类结构 */
        get_menu: `${PREFIX}/v1/message_center/menu/get`,
        /** 获取消息配置界面的交互分类结构 */
        get_config_menu: `${PREFIX}/v1/message_center/config_menu/get`,
        /** 获取某一交互分类下的所有配置 */
        get_config: `${PREFIX}/v1/message_center/config/get`,
        /** 根据配置id更新消息配置 */
        update_config: `${PREFIX}/v1/message_center/config/update`,
        /** 获取子产品未读消息 */
        suite_unread_list: `${PREFIX}/v1/message_center/suite/unread/list`,
        /** 获取互联组织未读消息 */
        get_unread_tenant_list: `${PREFIX}/v1/message_center/get_unread_tenant_list`,
        /** 获取一条未读的运营消息 */
        get_notice: `${PREFIX}/v1/message_center/notice/get`,
        /** 批量设置已读 */
        set_as_read: `${PREFIX}/v1/message_center/set_as_read`,
        /** 获取额外接收人 */
        get_extra_receiver: `${PREFIX}/v1/message_center/extra_receiver/list`,
        /** 添加消息额外接收人 */
        create_receiver: `${PREFIX}/tenant/:tenantId/admin/message/create_receiver`,
        /** 更新消息额外接收人 */
        update_receiver: `${PREFIX}/tenant/:tenantId/admin/message/update_receiver`,
        /** 获取消息额外接收人列表 */
        list_receiver: `${PREFIX}/tenant/:tenantId/admin/message/list_receiver`,
        /** 校验消息额外接收人 */
        validate_receiver: `${PREFIX}/tenant/:tenantId/admin/message/validate_receiver`,
        /** 删除消息额外接收人 */
        delete_receiver: `${PREFIX}/tenant/:tenantId/admin/message/delete_receiver`,
        /** 更新高管配置 */
        update_corp_executive: `${PREFIX}/tenant/:tenantId/admin/update_corp_executive`
    },
    login_page: {
        /** 企业用户 PC 端登录检查 */
        poll_qr_status: `${PREFIX}/tenant/:tenantId/poll_qr_status`,
        /** 企业用户app扫码登录后确认登录 */
        confirm_qr: `${PREFIX}/tenant/:tenantId/confirm_qr`,
        /** 验证corpUrl存在性 */
        verify_corp_url: `${PREFIX}/passport/verify_corp_url`,
        /** 独享版登录页判断是否单租环境并获取租户id */
        single_tenant_status: `${PREFIX}/passport/single_tenant_status`
    },
    ai: {
        /** 更新AI实验室开关配置 */
        update_lab_conf: `${PREFIX}/tenant/:tenantId/admin/ai/update_lab_conf`
    },
    authz: {
        /** 获取登录用户的平台权限信息 */
        get_permissions: `${PREFIX}/tenant/:tenantId/authz/get_permissions`,
        /** 获取 api 信息 */
        get_open_permission: `${PREFIX}/tenant/:tenantId/authz/get_open_permission`
    },
    sso: {
        /** 更新单点登录配置 */
        update_sso: `${PREFIX}/tenant/:tenantId/admin/sso/update_sso`
    },
    wechat: {
        /** 更新微信公众号集成开关 */
        update_enable: `${PREFIX}/tenant/:tenantId/admin/wechat/update_enable`,
        /** 微信服务号授权 URL 地址 */
        grant_uri: `${PREFIX}/tenant/:tenantId/admin/wechat_platform/grant_uri`,
        /** 微信服务号授权取消 */
        grant_revoke: `${PREFIX}/tenant/:tenantId/admin/wechat_platform/grant_revoke`,
        /** 获取微信消息模板列表 */
        template_list: `${PREFIX}/tenant/:tenantId/admin/wechat_platform/get_template_list`,
        /** 调取微信模板配置 */
        template_retrieval: `${PREFIX}/tenant/:tenantId/admin/wechat_platform/get_template`,
        /** 安装微信模板 */
        template_install: `${PREFIX}/tenant/:tenantId/admin/wechat_platform/install_template`
    },
    lark: {
        /** 飞书多模板授权安装请求 */
        install_issue: `${PREFIX}/tenant/:tenantId/admin/lark/cp/:platformSuiteId/:suiteScenario/install/issue`
    },
    integration: {
        /** 企业套件用户同步操作 */
        user_sync: `${PREFIX}/tenant/:tenantId/admin/integration/manage/corp/sync/manual`,
        /** 获取企业套件成员同步日志 */
        get_sync_logs: `${PREFIX}/tenant/:tenantId/admin/integration/manage/corp/sync/logs`,
        /** 获取企业套件定时同步配置 */
        get_cron_sync: `${PREFIX}/tenant/:tenantId/admin/integration/manage/corp/sync/status`,
        /** 配置企业套件自动同步设置 */
        set_cron_sync: `${PREFIX}/tenant/:tenantId/admin/integration/manage/corp/sync/cron/set`,
        /** 获取企业套件授权状态列表 */
        corp_suite_auth_status_list: `${PREFIX}/tenant/:tenantId/admin/integration/manage/corp/suite/auth_status/list`,
        /** 解绑企业 Isv 和 Corp Secret 授权信息 */
        corp_suite_unbind: `${PREFIX}/tenant/:tenantId/admin/integration/manage/corp/suite/unbind`
    },
    dingtalk: {
        load_authorizer_info: `${PREFIX}/dingtalk/load_authorizer_info`
    },
    order: {
        /** 订单系统-获取商品列表 */
        get_goods_list: `${PREFIX}/tenant/:tenantId/admin/order/get_goods_list`,
        /** 平台内容商业化-获取内容费用 */
        get_content_detail: `${PREFIX}/tenant/:tenantId/content/get_content_detail`,
        /** 订单系统-获取订单列表 */
        get_order_list: `${PREFIX}/tenant/:tenantId/admin/order/get_order_list`,
        /** 订单系统-校验订单是否支付 */
        check_paid: `${PREFIX}/tenant/:tenantId/admin/order/check_paid`,
        /** 订单系统-校验是否有未支付订单 */
        check_unpaid: `${PREFIX}/tenant/:tenantId/admin/order/check_unpaid`,
        /** 订单系统-提交订单 */
        submit: `${PREFIX}/tenant/:tenantId/admin/order/submit`,
        /** 订单系统-获取订单价格 */
        get_price: `${PREFIX}/tenant/:tenantId/admin/order/get_price`,
        /** 订单系统-申请开票 */
        issue_receipt: `${PREFIX}/tenant/:tenantId/admin/order/issue_receipt`,
        /** 订单系统-获取发票 */
        get_receipt: `${PREFIX}/tenant/:tenantId/admin/order/get_receipt`,
        /** 订单系统-获取默认发票 */
        get_default_receipt: `${PREFIX}/tenant/:tenantId/admin/order/get_default_receipt`,
        /** 订单系统-获取发票列表 */
        get_receipt_list: `${PREFIX}/tenant/:tenantId/admin/order/get_receipt_list`,
        /** 订单系统-获取订单详情 */
        get_order: `${PREFIX}/tenant/:tenantId/admin/order/get_order`,
        /** 订单系统-删除订单 */
        delete_order: `${PREFIX}/tenant/:tenantId/admin/order/delete_order`,
        /** 订单系统-获取支付信息 */
        get_payment: `${PREFIX}/tenant/:tenantId/admin/order/get_payment`,
        /** 订单系统-提交支付凭证 */
        submit_pay_proof: `${PREFIX}/tenant/:tenantId/admin/order/submit_pay_proof`,
        /** 订单系统-取消订单 */
        cancel_order: `${PREFIX}/tenant/:tenantId/admin/order/cancel_order`
    },
    webhook: {
        /** 管理后台-消息推送-获取消息 */
        get_webhook_config: `${PREFIX}/tenant/:tenantId/admin/webhook/get_webhook_config`,
        /** 管理后台-消息推送-更新消息 */
        update_webhook_config: `${PREFIX}/tenant/:tenantId/admin/webhook/update_webhook_config`,
        /** 管理后台-消息推送-获取消息日志 */
        get_webhook_logs: `${PREFIX}/tenant/:tenantId/admin/webhook/get_webhook_logs`,
        /** 管理后台-消息推送-测试消息推送 */
        test_webhook: `${PREFIX}/tenant/:tenantId/admin/webhook/test_webhook`
    },
    integrate: {
        /** 按当前租户的集成平台信息，生成用于打开应用或分享的 AppLink */
        create_applink: `${PREFIX}/integrate/applink/create`
    },
    jssdk: {
        /** 登录场景下调用该接口获取 jssdk 相关配置 */
        private_config: `${PREFIX}/integrate/jssdk/private/config`,
        /** 未登录场景下调用该接口获取 jssdk 相关配置 */
        public_config: `${PREFIX}/integrate/jssdk/public/config`
    },
    suite: {
        /** 校验成员是否可以访问套件 */
        check_access: `${PREFIX}/suite/:suiteId/check_access`,
        /** 获取套件可用范围 */
        get_visible_scope: `${PREFIX}/tenant/:tenantId/admin/suite/get_visible_scope`,
        /** 更新套件可用范围 */
        update_visible_scope: `${PREFIX}/tenant/:tenantId/admin/suite/update_visible_scope`,
        /** 启用套件 */
        enable: `${PREFIX}/tenant/:tenantId/admin/suite/enable`,
        /** 禁用套件 */
        disable: `${PREFIX}/tenant/:tenantId/admin/suite/disable`,
        /** 获取套件手动管理权限 */
        get_manage_permission: `${PREFIX}/tenant/:tenantId/admin/suite/get_manage_permission`
    },
    authentication: {
        /** 生成图片验证码 */
        generate_captcha: `${PREFIX}/authn/otp/generate_captcha`,
        /** 生成手机验证码 */
        send_sms: `${PREFIX}/authn/otp/send_sms`,
        /** 生成邮箱验证码 */
        send_email: `${PREFIX}/authn/otp/send_email`,
        /** 校验验证码 */
        verify_code: `${PREFIX}/authn/otp/verify_code`,
        /** 用户登录-二次认证 */
        verify_phone: `${PREFIX}/authn/mfa/verify_phone`,
        /** 校验用户密码 */
        verify_password: `${PREFIX}/authn/mfa/verify_password`,
        /** 二次登陆-绑定手机号 */
        bind_phone: `${PREFIX}/authn/mfa/bind_phone`,
        /** 用户注册 */
        register: `${PREFIX}/register`,
        /** 用户登录 */
        signin: `${PREFIX}/signin`,
        /** OAuth 回调绑定手机/邮箱 */
        bind: `${PREFIX}/register/bind`,
        /** 忘记密码邮件发送处理 */
        forget_password: `${PREFIX}/authn/password/forget_password`,
        /** 执行密码重置 */
        reset_password: `${PREFIX}/authn/password/reset_password`,
        /** 移动端修改密码-忘记密码验证码校验 */
        code_validate: `${PREFIX}/authn/password/code_validate`,
        /** 获取登录用户信息 */
        get_login_user: `${PREFIX}/authn/get_login_user`,
        /** 获取用户所加入的所有团队 */
        get_tenant_list: `${PREFIX}/account/get_tenant_list`,
        /** 切换登录企业 */
        switch_corp: `${PREFIX}/account/switch_corp`,
        /** 微信成员绑定 */
        wechat_platform_bind: `${PREFIX}/tenant/:tenantId/provider/wechat_platform/bind`
    },
    suite_integrate_authentication: {
        /** 钉钉免登 */
        dingtalk_login: `${PREFIX}/integrate/dingtalk/isv/:integrateCorpId/:suiteId/:suiteScenario/member/authcode/pc/v1/auth`
    },
    usage: {
        /** 获取平台套餐使用量 */
        get: `${PREFIX}/tenant/:tenantId/admin/usage/get_usage`,
        /** 获取互联组织套餐用量明细 */
        get_corp_coop_usage: `${PREFIX}/tenant/:tenantId/admin/usage/get_corp_coop_usage`
    },
    member_api: {
        /** MCP 状态开关 */
        update: `${PREFIX}/tenant/:tenantId/admin/member_api/update`
    },
    // 提醒屏蔽
    corp_executive: {
        /** 获取可屏蔽资源 */
        get_resource_list: `${PREFIX}/tenant/:tenantId/admin/corp_executive/get_resource_list`
    }
};
